import { useSelector } from 'react-redux';

import UserPermissionTypes from '@constants/permissions';
import useCheckPermission from '@hooks/checkPermission';

const useCanEditLead = () => {
  const { checkPermission } = useCheckPermission();
  const { rolesAndPermissions } = useSelector((state: any) => state.user);
  // checkPermission is fail-open while rolesAndPermissions is still the
  // initial {} — hide edit controls until permissions are actually loaded
  const arePermissionsLoaded =
    Object.keys(rolesAndPermissions ?? {}).length > 0;

  return (
    arePermissionsLoaded &&
    checkPermission([UserPermissionTypes.LEAD_MANAGEMENT_EDIT])
  );
};

export default useCanEditLead;
